import { render } from "./App.vue?vue&type=template&id=e5e1ca20&bindings={\"isPlaying\":\"data\",\"delay\":\"data\",\"score\":\"data\",\"showResults\":\"data\",\"start\":\"options\",\"endGame\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script